import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { vehicleExpensesValidationSchema} from "core/Operations/ValidationSchema/MasterValidationSchema";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
import { useInsertVehicleExpensesMutation } from "AppQuries/master/VehicleExpenses/vehicleexpenses";
import VehicleExpensesForm from "Components/Form/VehicleExpensesForm";
const AddVehicleExpenses = () => {
  const userData = useSelector(loggedInUser);
  const {
    mutate: insertVehicleExpenses,
    isPending,
    isError,
    error,
  } = useInsertVehicleExpensesMutation();
  const methods = useForm({
    defaultValues: {
      expenseID: "",
      insuranceNumber: "",
      insurancePeriod: "",
      insuranceAmount: 0,
      insuranceVendor: "",
      insuranceAgency: "",
      insuranceExpiryDate: "",
      craneInsuranceExpiryDate: "",
      lorryCraneLMCertExpiryDate: "",
      lgNextDueDate: "",
      roadTaxDueDate: "",
      inspectionDueDate: "",
      roadTaxInspectionAmount: 0,
      roadTaxInvRef: "",
      ncd: "",
      remarks: "",
      parkingNextDueDate: "",
      vpc: "",
      vpcAmount: 0,
      vpcAddress: "",
      parkingVendor: "",
      parkingLocation: "",
      parkingAmount: 0,
      parkingCouponNextDueDate: "",
      parkingAddress: "",
      parkingPaymentMode: "",
      fmtDueDate: "",
      fmtAmount: 0,
      shellCardNo: "",
      shellPIN: "",
      isActive: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    },
    resolver: yupResolver(vehicleExpensesValidationSchema),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
    watch,
  } = methods;
  const onSubmit = (payload) => {
    insertVehicleExpenses(payload, {
      onSuccess: (data) => {
        if (data) {
          toast.success("Added Successfully.");
          setTimeout(() => {
            navigate(`${all_routes.master}${all_routes.vehicleexpenses}`);
          }, 1000);
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add New Vehicle Expenses</h4>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Save Vehicle Expenses
                      </Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>

                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.master}/${all_routes.vehicleexpenses}`}
                      className="btn btn-secondary"
                    >
             <i className="fas fa-reply me-2"></i>
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">
                        Add Vehicle Expenses Details
                      </h4>
                    </div>
                    <div className="card-body">
                      <VehicleExpensesForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddVehicleExpenses;
